import { formatSsn } from '@zorro/common-utils';
import { Text } from '@zorro/web/design-system';

import { useAnalytics } from '../Analytics';
import { SensitiveValue } from '../SensitiveValue';

type Props = {
  ssn?: string | null;
  employeeId: string;
};

export const EmployeeSsnCell = ({ ssn, employeeId }: Props) => {
  const { sendEvent } = useAnalytics();

  if (!ssn) {
    return <Text size="sm">-</Text>;
  }

  return (
    <SensitiveValue
      value={formatSsn(ssn)}
      isSensitive
      isMasked
      size="sm"
      onReveal={() =>
        void sendEvent('ssn_revealed', { revealedEmployeeId: employeeId })
      }
    />
  );
};
